import { Chip, Tooltip } from '@mui/material';
import React from 'react'
import NoData from '../../../components/NoData';

const ChangesRequested = ({ projectDetails }) => {
    const reviewHistory = projectDetails?.changeRequests;
    // console.log("reviewHistory=>", reviewHistory);

    return (
        <div className="rounded-xl border border-gray-200 bg-white p-6 my-6">
            <div className="space-y-8">
                {reviewHistory?.length ? reviewHistory?.map((item, index) => (
                    <div key={index}>
                        {/* Date */}
                        <div className="mb-4">
                            <Chip size="md" label={item?.date} />
                        </div>

                        {/* Activities */}
                        <div className="space-y-4">
                            {item?.messages.map((message, ind) => (
                                <div
                                    key={ind}
                                    className="flex items-center justify-between rounded-xl border border-gray-200 px-3 py-1.5"
                                >
                                    <div className="flex items-center gap-3">
                                        <Tooltip placement='right' title={
                                            <div className='flex items-center gap-2 border p-2 rounded-md'>
                                                <div className='border w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium gap-0.5'>
                                                    {message?.requestedBy?.name?.split(" ")?.splice(0, 2)?.map((name, nameInd) => <span key={nameInd}>{name?.charAt?.(0)}</span>)}
                                                </div>
                                                <div className='space-y-1 '>
                                                    <h1 className='text-sm font-medium text-gray-900'>{message?.requestedBy?.name}</h1>
                                                    <p className='text-xs text-gray-600 '>{message?.requestedBy?.email}</p>
                                                </div>
                                            </div>}>
                                            <div className='border w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium gap-0.5'>
                                                {message?.requestedBy?.name?.split(" ")?.splice(0, 2)?.map((name, nameInd) => <span key={nameInd}>{name?.charAt?.(0)}</span>)}
                                            </div>
                                        </Tooltip>
                                        <p className="text-sm text-gray-700">{message?.message}</p>
                                    </div>

                                    <span className="shrink-0 text-sm text-gray-600">
                                        {message.time}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )) : <NoData />}
            </div>
        </div>
    )
}

export default ChangesRequested